"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExpressionEditor;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _textareaCaret = _interopRequireDefault(require("textarea-caret"));
var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));
var _reactContextmenu = require("react-contextmenu");
var _TextField = _interopRequireDefault(require("@mui/material/TextField/TextField.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _MenuList = _interopRequireDefault(require("@mui/material/MenuList/MenuList.js"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper/Paper.js"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText/ListItemText.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon/ListItemIcon.js"));
var _Popper = _interopRequireDefault(require("@mui/material/Popper/Popper.js"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _InfoOutlined = _interopRequireDefault(require("@mui/icons-material/InfoOutlined"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _makeStyles.default)(theme => ({
  expression: {
    width: '100%',
    ...makeContextMenuStyles(theme)
  },
  contextMenu: {
    padding: theme.spacing(1)
  },
  suggestion: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: theme.spacing(1)
  },
  highlight: {
    backgroundColor: theme.palette.primary.main,
    color: 'white !important'
  }
}));
function ExpressionEditor(props) {
  const {
    expression,
    suggestions: _s,
    onChange,
    onMount,
    getSuggestionValue,
    textFieldProps
  } = props;
  const [word, setWord] = (0, _react.useState)(null);
  const [filteredSuggestions, setFilteredSuggestions] = (0, _react.useState)([]);
  const [caret, setCaret] = (0, _react.useState)({
    top: 120,
    left: 20,
    height: 8
  });
  const textArea = (0, _react.useRef)(null);
  const contextMenuKey = (0, _react.useRef)((0, _utils.makeId)());
  const classes = useStyles();

  // filter empty sections and hidden suggestions
  const suggestions = _s.filter(s => s.type === 'section' ? Boolean(s.suggestions.length) : !s.hide).map(s => s.type === 'section' ? {
    ...s,
    suggestions: s.suggestions.filter(s => !s.hide)
  } : s);
  (0, _react.useEffect)(() => {
    onMount?.(textArea.current);
  }, []);
  const getWordAndRange = (text = textArea.current.value) => {
    if (!text) return {};
    const stopCharacters = [' ', '\n', '\r', '\t', '(', ')', ','];
    let start = textArea.current.selectionStart;
    let end = textArea.current.selectionEnd;
    while (start >= 0) {
      if (text[start] === '@') break;
      if (start === end || stopCharacters.indexOf(text[start]) === -1) {
        start--;
      } else {
        break;
      }
    }
    if (text[start] !== '@') start++;
    while (text[start] !== '@' && end < text.length) {
      if (stopCharacters.indexOf(text[end]) === -1) {
        end++;
      } else {
        break;
      }
    }
    const word = text.substr(start, end - start);
    return {
      word,
      start,
      end
    };
  };
  const getSuggestions = ({
    value,
    reason
  }) => {
    if (reason === 'input-focused') return;
    const {
      word
    } = getWordAndRange(value);
    if (!word || word.length === 0) setFilteredSuggestions([]);else {
      const search = word[0] === '@' ? word.slice(1) : word;
      const searchLen = search ? search.length : 0;
      if (searchLen === 0) setFilteredSuggestions(suggestions.map(s => s.type === 'section' ? s : {
        ...s,
        label: '',
        suggestions: [s]
      }));else {
        const isMatch = l => l.toLocaleLowerCase().slice(0, searchLen) === search.toLowerCase();
        const isExactMatch = l => l.toLowerCase() === search.toLowerCase();
        setFilteredSuggestions(suggestions.map(sug => sug.type === 'section' ? {
          ...sug,
          suggestions: sug.suggestions.filter(s => isMatch(sug.label) || !isExactMatch(s.label) && isMatch(s.label))
        } : {
          ...sug,
          label: '',
          ...(isMatch(sug.label) && {
            suggestions: [sug]
          })
        }).filter(s => s.suggestions?.length));
      }
    }
  };
  const addSuggestionToExpression = suggestion => {
    const {
      value
    } = textArea.current;
    const {
      start,
      end
    } = getWordAndRange();
    const display = getSuggestionValue ? getSuggestionValue(suggestion) : suggestion.value;
    return spliceString(value, start, end, display);
  };
  const handleClick = e => {
    e.preventDefault();
    if (textFieldProps?.onClick) textFieldProps.onClick(e);
    setCaret((0, _textareaCaret.default)(textArea.current, textArea.current.selectionEnd));
    const {
      word,
      start,
      end
    } = getWordAndRange();
    if (e.type === 'contextmenu' && (start || start === 0) && end) {
      e.target.setSelectionRange && e.target.setSelectionRange(start, end);
    }
    setWord(word);
  };
  const handleMenuSelect = (e, suggestion) => {
    const {
      value,
      selectionEnd
    } = textArea.current;
    const {
      start,
      end
    } = getWordAndRange();
    const display = getSuggestionValue ? getSuggestionValue(suggestion) : suggestion.value;
    onChange(e, spliceString(value, start, end, display), 'context-click');
    textArea.current.focus();
    textArea.current.setSelectionRange(selectionEnd, selectionEnd);
  };
  const handleMenuClose = (0, _react.useCallback)(() => setWord(null), []);
  const handleChange = (e, {
    newValue,
    method
  }) => {
    onChange(e, newValue, method);
    setCaret((0, _textareaCaret.default)(textArea.current, textArea.current.selectionEnd));
  };
  const contextMenuOptionsProps = {
    classes,
    word,
    handleMenuClose,
    handleMenuSelect,
    suggestions,
    id: contextMenuKey.current
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: classes.expression,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactContextmenu.ContextMenuTrigger, {
      id: contextMenuKey.current,
      holdToDisplay: -1,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactAutosuggest.default, {
        multiSection: true,
        suggestions: filteredSuggestions,
        onSuggestionsFetchRequested: getSuggestions,
        onSuggestionsClearRequested: () => setFilteredSuggestions([]),
        getSuggestionValue: addSuggestionToExpression,
        getSectionSuggestions: s => s.suggestions.length && s.suggestions,
        renderSectionTitle: s => s.suggestions.length && /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
          children: s.label
        }),
        renderSuggestion: (suggestion, {
          isHighlighted
        }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: (0, _classnames.default)(classes.suggestion, {
            [classes.highlight]: isHighlighted
          }),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText.default, {
            primaryTypographyProps: {
              color: 'inherit'
            },
            children: suggestion.label
          }), suggestion.description ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon.default, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(HelpIcon, {
              suggestion: suggestion
            })
          }) : null]
        }),
        inputProps: {
          ...textFieldProps,
          value: expression,
          onChange: handleChange,
          onClick: handleClick,
          onContextMenu: handleClick
        },
        renderInputComponent: p => /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
          inputRef: textArea,
          label: "Expression",
          placeholder: "Begin typing or right-click to see options.",
          multiline: true,
          fullWidth: true,
          rows: 3,
          variant: "outlined",
          autoFocus: true,
          ...p
        }),
        renderSuggestionsContainer: p => p.children && /*#__PURE__*/(0, _jsxRuntime.jsx)(SuggestionsContainer, {
          ...p,
          caret: caret,
          anchorEl: textArea.current
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(MemoizedContextMenuOptions, {
      ...contextMenuOptionsProps
    })]
  });
}
const useSuggestionsContainerStyles = (0, _makeStyles.default)(({
  border,
  palette
}) => ({
  suggestions: {
    zIndex: 1400
  },
  paper: {
    '& .react-autosuggest__suggestions-container--open': {
      display: 'block',
      position: 'absolute',
      width: 300,
      maxHeight: '150px',
      overflowY: 'auto',
      border: `1px solid ${palette.grayscale.dark}`,
      borderRadius: 4,
      color: palette.text.primary,
      background: palette.background.main,
      padding: '4px'
    },
    '& .react-autosuggest__suggestions-list': {
      listStyle: 'none',
      paddingLeft: 0
    },
    '& .react-autosuggest__suggestion': {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      cursor: 'pointer'
    }
  }
}));
function SuggestionsContainer({
  children,
  caret,
  anchorEl,
  containerProps
}) {
  const classes = useSuggestionsContainerStyles();

  // calculate popper offset from bottom-left of text area when there are suggestions
  const offset = (0, _react.useMemo)(() => {
    const x = caret.left;
    const y = caret.top + caret.height - anchorEl.offsetHeight;
    return [x, y];
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Popper.default, {
    anchorEl: anchorEl,
    open: true,
    placement: "bottom-start",
    className: classes.suggestions,
    popperOptions: {
      modifiers: [{
        name: 'offset',
        options: {
          offset
        }
      }]
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Paper.default, {
      className: classes.paper,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuList.default, {
        ...containerProps,
        children: children
      })
    })
  });
}
const spliceString = (str, start, end, add) => {
  const count = end - start;
  return str.slice(0, start) + (add || '') + str.slice(start + count);
};
const MemoizedContextMenuOptions = /*#__PURE__*/(0, _react.memo)(ContextMenuOptions);
function ContextMenuOptions({
  classes,
  word,
  handleMenuClose,
  handleMenuSelect,
  suggestions,
  id
}) {
  const makeContextMenuList = suggestion => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactContextmenu.MenuItem, {
    data: suggestion,
    onClick: handleMenuSelect,
    children: [suggestion.label, /*#__PURE__*/(0, _jsxRuntime.jsx)(HelpIcon, {
      suggestion: suggestion
    })]
  }, suggestion.label);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactContextmenu.ContextMenu, {
    id: id,
    hideOnLeave: true,
    onHide: handleMenuClose,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      variant: "caption",
      children: word ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: ["Replace ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
          children: word
        }), " with..."]
      }) : 'Select to insert.'
    }), suggestions.map(s => s.suggestions ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactContextmenu.SubMenu, {
      className: "lastMenu",
      title: s.label,
      children: s.suggestions.map(sug => makeContextMenuList(sug))
    }, s.label) : makeContextMenuList(s))]
  });
}
const useHelpIconStyles = (0, _makeStyles.default)({
  text: {
    fontSize: '0.65rem',
    color: 'inherit'
  }
});
function HelpIcon({
  suggestion
}) {
  const classes = useHelpIconStyles();
  const {
    description,
    example
  } = suggestion;
  if (!description && !example) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    placement: "right-start",
    title: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        className: classes.text,
        children: description
      }), example && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.default, {
        className: classes.text,
        children: ["ex: ", example]
      })]
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InfoOutlined.default, {
      fontSize: "small"
    })
  });
}
const makeContextMenuStyles = theme => ({
  '& .react-contextmenu': {
    backgroundColor: theme.palette.background.default,
    backgroundClip: 'padding-box',
    border: '1px solid rgba(0,0,0,.15)',
    borderRadius: '.25rem',
    fontSize: '16px',
    margin: '2px 0 0',
    minWidth: '210px',
    outline: 'none',
    opacity: '0',
    padding: '5px',
    pointerEvents: 'none',
    textAlign: 'left',
    transition: 'opacity 250ms ease !important'
  },
  '& .react-contextmenu.react-contextmenu--visible': {
    opacity: 1,
    pointerEvents: 'auto',
    zIndex: 9999
  },
  '& .react-contextmenu-item': {
    background: '0 0',
    border: '0',
    cursor: 'pointer',
    fontWeight: '400',
    padding: '4px 2px',
    textAlign: 'inherit',
    whiteSpace: 'nowrap',
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  '& .react-contextmenu-item.react-contextmenu-item--active': {
    color: '#fff',
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    textDecoration: 'none'
  },
  '& .react-contextmenu-item.react-contextmenu-item--selected': {
    color: '#fff',
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    textDecoration: 'none',
    '& svg': {
      color: '#fff'
    }
  },
  '& .react-contextmenu-item.react-contextmenu-item--disabled': {
    backgroundColor: 'transparent',
    borderColor: 'rgba(0,0,0,.15)',
    color: '#878a8c',
    '&:hover': {
      backgroundColor: 'transparent',
      borderColor: 'rgba(0,0,0,.15)',
      color: '#878a8c'
    }
  },
  '& .react-contextmenu-item--divider': {
    borderBottom: '1px solid rgba(0,0,0,.15)',
    cursor: 'inherit',
    marginBottom: '3px',
    padding: '2px 0'
  },
  '& .react-contextmenu-item.react-contextmenu-submenu': {
    padding: '0'
  },
  '& .react-contextmenu .lastMenu': {
    maxHeight: '50vh',
    overflowY: 'scroll',
    overflowX: 'visible'
  },
  '& .react-contextmenu-item.react-contextmenu-submenu > .react-contextmenu-item': {
    '&:after': {
      content: '"▶"',
      display: 'inline-block',
      position: 'absolute',
      right: '7px'
    }
  }
});